import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useScrollTop } from '../../hooks/useScrollTop';
import { AnimatePresence, motion } from 'framer-motion';

const MainLayout = () => {
  // Aplicar el hook para resetear el scroll en cada cambio de ruta
  useScrollTop();

  return (
    <div className='flex min-h-screen flex-col bg-gradient-to-br from-white to-background/30'>
      <Header />
      <motion.main
        className='flex-grow'
        tabIndex={-1}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        <AnimatePresence mode='wait'>
          <Outlet />
        </AnimatePresence>
      </motion.main>
      <Footer />
    </div>
  );
};

export default MainLayout;
